export class User {
    userName: string;
    password: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
    userRole: string;
    userToken: string;
}